// import './assets/main.css'
// 引入unocss
import '@/plugins/unocss'
// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n'

// 引入状态管理
import { setupStore } from '@/store'

// 路由
import { setupRouter } from './router'

import { createApp } from 'vue'
import { loadmore } from '@/directives/index.js'
import { message } from '@/utils/resetMessage.js'
// import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'

// 引入全局样式
import '@/styles/index.scss'
import 'element-plus/es/components/message/style/css'

import App from './App.vue'

import './permission'

// import { setupProdMockServer } from '../mock/mockProdServer'
// setupProdMockServer()

const setupAll = async () => {
  const app = createApp(App)

  app.directive('loadmore', loadmore)

  app.config.globalProperties.$msg = message // 挂载

  await setupI18n(app)

  setupStore(app)
  // app.use(ElementPlus)

  setupRouter(app)

  app.mount('#app')

  window.addEventListener('storage', (e) => {
    const { key, newValue, oldValue } = e
    if (key === 'user') {
      const newToken = JSON.parse(newValue || '{}')?.token
      const oldToken = JSON.parse(oldValue || '{}')?.token
      if (newToken !== oldToken) {
        window.location.reload()
      }
    }
  })
}

setupAll()
